@if (!store.isSummary) {
    <ap-previous-button (click)="previousQuestion()"></ap-previous-button>
    <div class="bold">{{ 'financial-obligations.private-lease.title' | apContent }}</div>
}

@if (showPrivateLeaseAmount()) {
    <private-lease-amount></private-lease-amount>
}
@if (showPrivateLeaseMonths()) {
    <private-lease-months></private-lease-months>
}
